import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const RULES_LIST_URL = "agency/admin/permissions-list/";

export const fetchRulesList = createAsyncThunk(
  "rules/fetchRulesList",
  async (params, thunkAPI) => {
    try {
      const state = thunkAPI.getState();
      const token = state.auth.token;
      if (!token) {
        return;
      }

      const response = await axios.get(RULES_LIST_URL, {
        params,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to fetch rules list"
      );
    }
  }
);

const initialState = {
  rules_list: [],
  error: false,
  loading: false,
};

const rulesSlice = createSlice({
  name: "rules",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRulesList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRulesList.fulfilled, (state, action) => {
        state.loading = false;
        state.rules_list = action.payload;
      })
      .addCase(fetchRulesList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
        state.rules_list = [];
      });
  },
});

export default rulesSlice.reducer;
